import { render, staticRenderFns } from "./orderSend.vue?vue&type=template&id=4e77f1eb&scoped=true&"
import script from "./orderSend.vue?vue&type=script&lang=js&"
export * from "./orderSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e77f1eb",
  null
  
)

export default component.exports